/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";

import AuthApiInterceptors from "./modules/base/services/AuthApiInterceptors"
import ResApiInterceptors from "./modules/base/services/ResApiInterceptors";
import AuthService from "./modules/base/services/AuthService";
import StorageService from "./modules/base/services/StorageService";

const baseURL = process.env.REACT_APP_BASE_URL
let sessionTimeoutTime

// const sessionTimoutTime = StorageService.getSessionTimeout()



let idleTime = 0
let intervalId = null
let logoutTriggered = false

const handleIdle = () => {
  idleTime = 0
}

const resetIdleTime = () => {
  StorageService.getSessionTimeout().then((timeout) => {
    sessionTimeoutTime = timeout
  })
  idleTime++
  if (idleTime > sessionTimeoutTime) {
    console.log("triggered")
    // Call logout function here
    logout()
    logoutTriggered = true // Set the flag to indicate logout has been triggered
  }
}

const startIdleTimer = () => {
  document.addEventListener("mousemove", handleIdle)
  document.addEventListener("keydown", handleIdle)
  document.addEventListener("mouseover", handleIdle)
  document.addEventListener("scroll", handleIdle)
  intervalId = setInterval(resetIdleTime, 1000)
}

const stopIdleTimer = () => {
  document.removeEventListener("mousemove", handleIdle)
  document.removeEventListener("keydown", handleIdle)
  clearInterval(intervalId)
}

 const logout = async () => {
   await AuthService.Logout()
  //  window.history.pushState({}, "", "/sessionTimout")
  window.location.href = baseURL+"/sessionTimout"
 }

startIdleTimer()


const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
AuthApiInterceptors()
ResApiInterceptors()
